import { useEffect, useState } from 'react';
import { apiGet } from '../services/api';

let cachedCountries = null;

export function useCountries() {
  const [countries, setCountries] = useState(cachedCountries ?? []);
  const [loading, setLoading] = useState(cachedCountries === null);

  useEffect(() => {
    if (cachedCountries !== null) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function load() {
      setLoading(true);
      try {
        const res = await apiGet('/api/v1/countries');
        if (!res.ok) {
          throw new Error('countries');
        }
        const json = await res.json();
        if (!cancelled) {
          const next = Array.isArray(json.data) ? json.data : [];
          cachedCountries = next;
          setCountries(next);
        }
      } catch {
        if (!cancelled) {
          setCountries([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { countries, loading };
}
